"use client";

import dynamic from "next/dynamic";

const SupportWidgetManager = dynamic(() => import("@lib/support-widgets/SupportWidgetManager"), {
    ssr: false,
});

const ContextDependentScripts = () => {
    return <SupportWidgetManager />;
};

export default ContextDependentScripts;
